(function GroupComponentSave($, Adzuki)
{
	"use strict";

	Adzuki.onload(['GroupComponents/edit/', 'GroupComponents/add/'], init);

	function init() {
		showComponentTypeFields($('#groupcomponentsave-groupcomponent-component_type').val());

		$('#groupcomponentsave-groupcomponent-component_type').on('change', function showFields() {
			showComponentTypeFields($('#groupcomponentsave-groupcomponent-component_type').val());
		});

		$('#groupcomponentsave-groupcomponent-show_detailed_pricing').on('click', toggleDetailedPricing);
		$('#groupcomponentsave-groupcomponent-line_item_additional_fees').on('click', toggleCustomLabels);

		toggleDetailedPricing();
		toggleCustomLabels();
		displayAllInclusivePropertyField();
	}

	$(document).ready(function documentReady() {
		// This doesn't work properly if you do it in the init above.. *shrug*
		$('#groupcomponentsave-groupcomponent-departure_date').on('dp.change', startDateChanged);

		// Get all-inclusive propertie when hotel is selected
		$('#groupcomponentsave-groupcomponent-hotel_id').on('change', function change(e) {
			displayAllInclusivePropertyField();
		});

		// Get all-inclusive propertie when tour company is selected
		$('#groupcomponentsave-groupcomponent-tour_company_id').on('change', function change(e) {
			displayAllInclusivePropertyField();
		});

		// Set destination when property is selected
		$('#groupcomponentsave-groupcomponent-all_inclusive_property_id').on('change', function change(e) {
			populateDestinationByProperty($(this).val());
		});
	});

	function displayAllInclusivePropertyField() {
		var component_type = $('#groupcomponentsave-groupcomponent-component_type').val(),
			existing_vendor_table,
			existing_vendor_id;

		// Hide row by default
		$('#all_inclusive_property_row').addClass('hidden');

		// Check for all-inclusive properties if package or lodging
		if (component_type === 'package' || component_type === 'lodging') {
			if (component_type === 'package') {
				existing_vendor_table = 'tour_companies';
				existing_vendor_id    = $('#groupcomponentsave-groupcomponent-tour_company_id').val();
			} else {
				existing_vendor_table = 'hotels';
				existing_vendor_id    = $('#groupcomponentsave-groupcomponent-hotel_id').val();
			}

			getAllInclusiveProperties(component_type, existing_vendor_table, existing_vendor_id);
		}
	}

	function getAllInclusiveProperties(component_type, existing_vendor_table, existing_vendor_id) {
		var $properties = $('#groupcomponentsave-groupcomponent-all_inclusive_property_id'),
		    vendor_id   = $('#groupcomponentsave-groupcomponent-vendor_id').val(),
		    property_id = $properties.val();

		$properties.empty();
		$properties.append($('<option>').text('').attr('value', ''));

		// get vendor id
		Adzuki.Ajax.get('/Vendors/getVendorId/' + component_type + '/' + existing_vendor_table + '/' + existing_vendor_id).then(function success(vendor) {
			$('#groupcomponentsave-groupcomponent-vendor_id').val(vendor.vendor_id);

			vendor_id = vendor.vendor_id;

			if (vendor_id === '') {
				return;
			}

			Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
				var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

				if (sorted_properties.length > 0) {
					$.each(sorted_properties, function loadProperty(i, property) {
						$properties.append($('<option>').text(property.value).attr('value', property.key));
					});

					if (typeof $properties.data('selected-id') !== 'undefined') {
						property_id = $properties.data('selected-id');
						$properties.removeAttr('data-selected-id');
						$properties.removeData('selected-id');
					}

					$properties.val(property_id);

					$('#all_inclusive_property_row').removeClass('hidden');
				}
			});
		});
	}

	function populateDestinationByProperty(property_id) {
		Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
			// set destination
			$('#groupcomponentsave-groupcomponent-destination_id').val(property.country_id);

			// set location
			$('#groupcomponentsave-groupcomponent-location').val(property.country);
		});
	}

	function showComponentTypeFields(component_type) {
		$('.group-component-field').each(function hideField(index, el) {
			$(el).addClass('hidden');
		});

		// Set Depature/Return Date labels based on component_type
		if (component_type === 'lodging') {
			$('#departure-date-label').text('Check In');
			$('#return-date-label').text('Check Out');
		} else {
			$('#departure-date-label').text('Departure Date');
			$('#return-date-label').text('Return Date');
		}

		$('.' + component_type + '-field').each(function showField(index, el) {
			$(el).removeClass('hidden');
		});
	}

	function startDateChanged(e) {
		var startDate = e.date,
			endDate   = $('#groupcomponentsave-groupcomponent-return_date').data('DateTimePicker');

		// if the start date is greater than the end date, add 30 days to the end
		if (endDate.date() === null || endDate.date().isBefore(startDate) === true) {
			endDate.date(startDate.add(1, 'days'));
		}
	}

	function toggleDetailedPricing() {
		var checked = $('#groupcomponentsave-groupcomponent-show_detailed_pricing').prop('checked');

		if (checked) {
			$('#line-item-additional-fees-row').removeClass('hidden');
		} else {
			$('#line-item-additional-fees-row').addClass('hidden');
			$('#groupcomponentsave-groupcomponent-line_item_additional_fees').prop('checked', false);
		}

		toggleCustomLabels();
	}

	function toggleCustomLabels() {
		var $self = $('#groupcomponentsave-groupcomponent-line_item_additional_fees'), checked = $self.prop("checked");

		if (checked === true) {
			$('#custom-label-fields').removeClass('hidden');
		} else {
			$(".custom-label").val('');
			$('#custom-label-fields').addClass('hidden');
		}
	}

}(jQuery, window.Adzuki || {}));
